var exports = {
  "Lw": "VoiceRegionTeleportOverlay.module__overlay___OVJFTF",
  "t5": "VoiceRegionTeleportOverlay.module__voiceRegionTeleportFadeIn___OVJFTF",
  "Vs": "VoiceRegionTeleportOverlay.module__tile___OVJFTF",
  "Pf": "VoiceRegionTeleportOverlay.module__label___OVJFTF",
};

module.exports = exports;
